<script>
export default {
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null;
      if (cInfo && cInfo.primary_color) {
        document.body.style.backgroundColor = cInfo.primary_color;
      }
      return cInfo;
    },
    langSelected: {
      get() {
        return this.$store.state.language.language;
      },
      set(val) {
        this.$store.commit("language/SET_LANGUAGE", val);
      },
    },
    langFlagSelected: function () {
      return this.$store.state.language.languages.find(
        (x) => this.langSelected === x.value
      ).flag;
    },
  },
  created: () => {
    document.body.classList.add("authentication-bg");
    document.body.classList.add("authentication-bg-pattern");
  },
};
</script>

<template>
  <div>
    <!-- Traduction options -->
    <div class="flag-language float-right"></div>
    <!-- content -->
    <div class="account-pages pt-5 mb-4">
      <div class="container">
        <slot />
      </div>
    </div>
    <footer class="footer footer-alt">
      &copy; {{ $t("copyright") }}, {{ currentYear }},
      {{
        getCompanyInfo && getCompanyInfo.company_name ? getCompanyInfo.company_name : ""
      }}
      {{
        getCompanyInfo && getCompanyInfo.git_version
          ? " | " + getCompanyInfo.git_version
          : ""
      }}
    </footer>
  </div>
</template>

<style lang="scss" scoped>
.flag-language {
  position: absolute;
  top: 2px;
  right: 2px;
  .flag {
    padding: 0.5rem;
    display: inline-flex;
    list-style: none !important;
  }
}
</style>
